<template lang="pug">
.nav-container(:class="[\
  'type-' + type, \
  showNav && 'active' \
  ]"
)
  .nav-item.flex-mid(
      v-for="(item, index) in navList",
      :class="{ active: index === activeNav }",
      @click="changeNav(index)"
    )
      span.nav-name {{ item }}
      .line
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { FULI_MODULE_NAV } from '../consts';

export default {
  props: {
    navList: {
      type: Array,
      default: () => [],
    },
    showNav: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: 1,
    },
    activeNav: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    changeNav(index) {
      const key = this.navList[index];
      if (key === FULI_MODULE_NAV.welfare_exclusive_new) {
        UBT.clickButton({
          pageId: 'welfare_new',
          buttonName: 'APPcc_tab',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else if (key === FULI_MODULE_NAV.welfare_card_new) {
        UBT.clickButton({
          pageId: 'welfare_new',
          buttonName: 'coupon_tab',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else if (key === FULI_MODULE_NAV.welfare_task_new) {
        UBT.clickButton({
          pageId: 'welfare_new',
          buttonName: 'getbouns_tab',
          categoryId: 'platform',
          businessInfo: {},
        });
      } else if (key === FULI_MODULE_NAV.welfare_bountyExchange) {
        UBT.clickButton({
          pageId: 'welfare_new',
          buttonName: 'use_bonustab',
          categoryId: 'platform',
          businessInfo: {},
        });
      }

      this.$emit('changeNav', index);
    },
  },
};
</script>
<style scoped lang="less">
  .nav-container {
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    overflow-y: auto;

    .nav-item {
      flex-direction: column;
      flex: 1;
      margin-right: 0.1rem;

      .nav-name {
        font-size: 0.16rem;
        line-height: 0.22rem;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        margin-bottom: 0.03rem;
      }

      .line {
        width: 0.26rem;
        height: 0.04rem;
        background: #fff7f5;
        border-radius: 0.02rem;
        opacity: 0;
        transition: all 0.2s ease;
      }

      &.active {
        .nav-name {
          font-size: 0.16rem;
          font-weight: 500;
          color: #fff;
        }

        .line {
          opacity: 1;
        }
      }
    }

    &.type-1 {
      margin: 0 0.16rem 0.13rem;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }
    }

    &.type-2 {
      position: fixed;
      width: 100%;
      left: 0;
      right: 0;
      top: 0;
      background: #5a46e5;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s ease;
      box-shadow: 0 0.01rem 0.06rem 0 rgba(0, 0, 0, 0.06);
      z-index: 100;
      padding: 0.11rem 0.16rem 0.11rem;
      white-space: nowrap;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
        width: 0;
        height: 0;
        color: transparent;
      }

      &.active {
        opacity: 1;
        pointer-events: unset;
      }
    }
  }
</style>
